module.exports = __webpack_public_path__ + "static/directors1-bd21ac09ae7239819edbb1a2c75f0180.jpg";